import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { FaXTwitter } from "react-icons/fa6";

import styles from "./ShareButtons.module.css";

function TwitterShareButton({ className }) {
  const { asPath, isReady } = useRouter();
  const [location, setLocation] = useState("");

  useEffect(() => {
    if (isReady)
      setLocation(asPath);
  }, [isReady, asPath]);

  const uri = encodeURI(`https://kvrx.org${location}`);
  return (
    <a
      href={`https://twitter.com/intent/tweet?url=${uri}`}
      role="button"
      className={`${className} btn btn-default ${styles["share-links"]}`}
      id={styles.twitter}
      target="_blank"
      rel="noopener noreferrer"
    >
      <span>Tweet</span> <FaXTwitter />
    </a>
  );
}

export default TwitterShareButton;
